import EntidadeService from '@/api/entidade-service';
import {
  FETCH_ENTIDADES_ACTION,
  INITIALIZE_FROM_COOKIES_ACTION,
  INITIALIZE_FROM_VALUE,
  SET_ENTIDADE_ACTION,
} from './actions.type';
import {
  SET_ENTIDADES,
  SET_ENTIDADE,
  INITIALIZE_FROM_COOKIES,
  SET_ENTIDADE_FROM_ID,
  SET_LOADING,
} from './mutations.type';

export default {
  [SET_ENTIDADE_ACTION](context, data) {
    context.commit(SET_ENTIDADE, data);
  },
  [FETCH_ENTIDADES_ACTION](context) {
    if (context.state.entidades && context.state.entidades.length) {
      return Promise.resolve();
    }
    context.commit(SET_LOADING, true);
    return EntidadeService.getEntidades()
      .then(({ data }) => {
        const entidades = data ? data.filter(e => e.tipo === 'COMPRADOR') : [];
        context.commit(SET_ENTIDADES, entidades);
      })
      .finally(() => {
        context.commit(SET_LOADING, false);
      });
  },
  async [INITIALIZE_FROM_VALUE](context, idEntidade) {
    await context.dispatch(FETCH_ENTIDADES_ACTION);
    context.commit(SET_ENTIDADE_FROM_ID, idEntidade);
  },
  async [INITIALIZE_FROM_COOKIES_ACTION](context) {
    await context.dispatch(FETCH_ENTIDADES_ACTION);
    context.commit(INITIALIZE_FROM_COOKIES);
  },
};
